export default "__VITE_PUBLIC_ASSET__ed7dd517__"